import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Archive, Cloud, HardDrive, Save, Loader2 } from 'lucide-react';

export const ArchiveSettingsDialog = ({ open, onOpenChange, archiveForm, setArchiveForm, onSave, saving }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2"><Archive className="h-5 w-5 text-[#00A3A3]" />Archive Settings</DialogTitle>
        <DialogDescription>Configure how records are archived and stored</DialogDescription>
      </DialogHeader>
      <div className="space-y-5 py-2">
        <div className="space-y-2"><Label>Archive Frequency</Label>
          <Select value={archiveForm.frequency} onValueChange={v => setArchiveForm({ ...archiveForm, frequency: v })}>
            <SelectTrigger data-testid="archive-frequency-select"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="monthly">Monthly</SelectItem><SelectItem value="quarterly">Quarterly</SelectItem><SelectItem value="yearly">Yearly</SelectItem><SelectItem value="manual">Manual Only</SelectItem></SelectContent>
          </Select>
        </div>
        <div className="space-y-2"><Label>Retention Period (days)</Label>
          <Input type="number" value={archiveForm.retention_days} onChange={e => setArchiveForm({ ...archiveForm, retention_days: e.target.value })} data-testid="retention-days-input" />
        </div>
        <div className="space-y-2"><Label>Download Destination</Label>
          <Select value={archiveForm.download_destination} onValueChange={v => setArchiveForm({ ...archiveForm, download_destination: v })}>
            <SelectTrigger data-testid="download-destination-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="computer"><div className="flex items-center gap-2"><HardDrive className="h-4 w-4" />Local Download</div></SelectItem>
              <SelectItem value="cloud"><div className="flex items-center gap-2"><Cloud className="h-4 w-4" />Cloud Storage</div></SelectItem>
            </SelectContent>
          </Select>
        </div>
        {archiveForm.download_destination === 'cloud' && (
          <Card className="border-[#E2E6EA] bg-[#FAFBFC]"><CardContent className="p-4 space-y-3">
            <p className="text-sm font-medium text-[#1A1D21] flex items-center gap-2"><Cloud className="h-4 w-4 text-[#00A3A3]" />Cloud Configuration</p>
            <div><Label className="text-xs">Provider</Label>
              <Select value={archiveForm.cloud_provider} onValueChange={v => setArchiveForm({ ...archiveForm, cloud_provider: v })}>
                <SelectTrigger data-testid="cloud-provider-select"><SelectValue placeholder="Select" /></SelectTrigger>
                <SelectContent><SelectItem value="google_drive">Google Drive</SelectItem><SelectItem value="onedrive">OneDrive</SelectItem><SelectItem value="dropbox">Dropbox</SelectItem></SelectContent>
              </Select>
            </div>
            <div><Label className="text-xs">API Key</Label><Input type="password" value={archiveForm.cloud_api_key} onChange={e => setArchiveForm({ ...archiveForm, cloud_api_key: e.target.value })} data-testid="cloud-api-key-input" /></div>
            <div><Label className="text-xs">Folder ID</Label><Input value={archiveForm.cloud_folder_id} onChange={e => setArchiveForm({ ...archiveForm, cloud_folder_id: e.target.value })} data-testid="cloud-folder-input" /></div>
          </CardContent></Card>
        )}
        <div className="space-y-3">
          <label className="flex items-center gap-3 cursor-pointer">
            <input type="checkbox" checked={archiveForm.auto_archive_enabled} onChange={e => setArchiveForm({ ...archiveForm, auto_archive_enabled: e.target.checked })} className="rounded" data-testid="auto-archive-toggle" />
            <div><p className="text-sm font-medium text-[#1A1D21]">Auto-archive</p><p className="text-xs text-[#A8B1B9]">Archive records after retention period</p></div>
          </label>
          <label className="flex items-center gap-3 cursor-pointer">
            <input type="checkbox" checked={archiveForm.notify_on_archive} onChange={e => setArchiveForm({ ...archiveForm, notify_on_archive: e.target.checked })} className="rounded" data-testid="notify-archive-toggle" />
            <div><p className="text-sm font-medium text-[#1A1D21]">Notify before archive</p><p className="text-xs text-[#A8B1B9]">Send reminder before archiving</p></div>
          </label>
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button onClick={onSave} disabled={saving} className="bg-[#00A3A3] hover:bg-[#008585]" data-testid="save-archive-settings-btn">
          {saving ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <Save className="h-4 w-4 mr-1" />}Save
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
